import { createFileRoute, redirect } from "@tanstack/react-router";
import { authClient } from "@/auth";
import { MainLayout } from "@/layouts/main-layout/MainLayout";
import { orpc } from "@/orpc/client";

export const Route = createFileRoute("/_app")({
	beforeLoad: async () => {
		const { data: authSession } = await authClient.getSession();

		if (!authSession?.user) {
			throw redirect({ to: "/auth/signin" });
		}

		const isAdmin =
			authSession.user.role === "admin" ||
			authSession.user.role === "super_admin";

		if (!authSession.user.acceptedTermsAt && !isAdmin) {
			throw redirect({ to: "/terms" });
		}

		return { authSession };
	},
	loader: async ({ context: { queryClient, authSession } }) => {
		const isAdmin =
			authSession.user.role === "admin" ||
			authSession.user.role === "super_admin";

		const [subscription] = await Promise.all([
			queryClient.ensureQueryData(orpc.billing.getSubscription.queryOptions()),
			queryClient.prefetchQuery(orpc.apps.list.queryOptions()),
		]);

		if (
			!isAdmin &&
			(subscription.status === "incomplete" ||
				subscription.status === "incomplete_expired")
		) {
			throw redirect({ to: "/checkout" });
		}
	},
	component: MainLayout,
});
